module.exports = __webpack_public_path__ + "img/empty.38904f93.svg";